import React, { Component } from 'react';
import { TableCell } from '@mui/material';
import { formatPhoneNumberForUi } from '../../utils/formatNumber';

class GridPhoneCell extends Component {
    //props: field, value, row
    render() {
        const formattedNumber = formatPhoneNumberForUi(this.props.value);
        const baseStyle = this.props.styles;
        return (
            // One line: "+1 (234) 567-89" broke after its hyphen.
            <TableCell align="left" sx={{ whiteSpace: 'nowrap', ...baseStyle }}>
                {formattedNumber}
            </TableCell>
        );
    }
}

export default GridPhoneCell;
